import * as Yup from "yup";

export const addVaribleValueSchema = Yup.object().shape({
  su_custom_variables_id: Yup.string()
    .trim()
    .required("custom variables is required"),
  su_survey_id: Yup.string().trim().required("su_survey_id is required"),
  su_section_id: Yup.string().trim().required("su_section_id is required"),
  su_question_id: Yup.string().trim().required("su_question_id is required"),
  su_value: Yup.string().trim().required("value is required"),
});